import { onMounted as I, onUnmounted as M } from "vue";
import { u as N } from "../stores/auth.al0TMRKc.js";
import { u as m } from "../stores/messaging.KQm3MfBf.js";
import { differenceInMinutes as A } from "date-fns";
function b(n = []) {
  let t = [], i = null, o = new AbortController();
  const e = N();
  let a = {};
  n.includes("messagingUnreadMessages") || (a = m());
  const c = {
    appBadgeCounts: {
      fn: e.refreshAppBadgeCounts,
      intervalMins: 1
    },
    userPing: {
      fn: l,
      intervalMins: 5
    },
    messagingUnreadMessages: {
      fn: a.updateUnreadMessages,
      intervalMins: 1,
      immediate: !0
    }
  };
  async function l() {
    if (document.visibilityState === "visible" && (i === null || A(/* @__PURE__ */ new Date(), i) >= 5))
      try {
        await e.userPing(), i = /* @__PURE__ */ new Date();
      } catch (r) {
        console.warn("Failed userPing", r);
      }
  }
  function s() {
    return e.hasCheckedUser && e.isSignedIn;
  }
  function g() {
    for (const [r, { fn: u, intervalMins: d, immediate: S }] of Object.entries(
      c
    )) {
      if (n.includes(r))
        continue;
      const _ = Math.floor(Math.random() * 60);
      setTimeout(() => {
        t.push(
          setInterval(
            () => {
              try {
                s() && u();
              } catch (E) {
                console.error("Error during polling:", E);
              }
            },
            d * 60 * 1e3
          )
        );
      }, _ * 1e3), S && s() && u();
    }
    n.includes("userPing") || document.addEventListener(
      "visibilitychange",
      () => {
        s() && l();
      },
      { signal: o.signal }
    );
  }
  function f() {
    t.forEach(clearInterval), t = [], o.abort();
  }
  I(() => {
    g();
  }), M(() => {
    f();
  });
}
export {
  b as u
};
